export const REPROCESS_DATA = "REPROCESS_DATA";
export const REPROCESS_DATA_SUCCESS = "REPROCESS_DATA_SUCCESS";
export const REPROCESS_DATA_FAILED = "REPROCESS_DATA_FAILED";

export const DELETE_USER_SCREENSHOTS = "DELETE_USER_SCREENSHOTS";
export const DELETE_USER_SCREENSHOTS_SUCCESS =
  "DELETE_USER_SCREENSHOTS_SUCCESS";
export const DELETE_USER_SCREENSHOTS_FAILED = "DELETE_USER_SCREENSHOTS_FAILED";

export const RESET_MAINTENANCE_STUFF = "RESET_MAINTENANCE_STUFF";

export const SEND_EMAIL_REPORT = "SEND_EMAIL_REPORT";
export const SEND_EMAIL_REPORT_SUCCESS = "SEND_EMAIL_REPORT_SUCCESS";
export const SEND_EMAIL_REPORT_FAILED = "SEND_EMAIL_REPORT_FAILED";
